import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import { useGetTestPackagesQuery } from "../../../../Service/LabManagement";
import ViewTestPackages from "./ViewTestPackages";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import { useDispatch } from "react-redux";
import Loader from "../../../../Component/DigitalMarketing/Loader";
import DashTabs from "./DashTabs";
 
const TestPackages = () => {
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState(1);
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [updateData, setUpdateData] = useState(null); // Selected data for viewing/updating
  const dispatch = useDispatch()
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
 
  const { data: TestPackageData, isLoading } = useGetTestPackagesQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
 
  useEffect(() => {
    const data: any = {
      first: "Test Package"
    };
    dispatch(Change(data));
  }, [view,show,updateData]);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} onChange={onChangeSearch} />
        </Col>
        {show && (
          <Col md={7} className="d-flex justify-content-end">
            {view && <DashTabs show={show} setShow={setShow} />}
          </Col>
        )}
      </Row>
 
      <div className="row mt-4">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            searchValue={searchValue}
            TestPackageData={TestPackageData}
            setShow={setShow}
            setUpdateData={setUpdateData}
            setView={setView}
          />
        </div>
        {show && (
          <div className="col-4" style={{ backgroundColor: "white" }}>
            <ViewTestPackages
              updateData={updateData}
              view={view}
              setShow={setShow}
            />
          </div>
        )}
        <Pagination
          setPagination={setPagination}
          pagination={pagination}
          data={TestPackageData}
        />
      </div>
    </div>
  );
};
 
export default TestPackages;
 